import moment from 'moment';
import { css } from '@emotion/react';
import TextField from '@material-ui/core/TextField';

import Button from './Button';
import OrderProduct from './OrderProduct';

/* eslint-disable no-mixed-operators */

const calculateTotal = (order) => {
  let total = 0.0;
  order.order_products.forEach((orderProduct) => {
    if (order.order_state === 'Started') {
      total += orderProduct.requested_quantity * orderProduct.price;
    } else {
      total += orderProduct.filled_quantity * orderProduct.price;
    }
  });
  return total;
};

const calculateTotalByWeight = (order) => {
  let total = 0.0;
  order.order_products.forEach((orderProduct) => {
    if (orderProduct.product.sold_by_weight) {
      if (order.order_state === 'Started') {
        total += orderProduct.requested_quantity * orderProduct.price;
      } else {
        total += orderProduct.filled_quantity * orderProduct.price;
      }
    }
  });
  return total;
};

const calculateDelivery = (order, service, hub, subtotal, deliveryMode) => {
  if (deliveryMode && deliveryMode === 'delivery' && service) {
    const mySelectedDeliveryService = order.available_delivery_services.filter((s) => (s.id === service))[0];
    let price = parseFloat(mySelectedDeliveryService.price);
    if (mySelectedDeliveryService.free_delivery_minimum && mySelectedDeliveryService.free_delivery_minimum > 0) {
      if (subtotal > mySelectedDeliveryService.free_delivery_minimum) {
        price = 0.0;
      }
    }
    return price;
  }
  if (deliveryMode && deliveryMode === 'hub' && hub) {
    return parseFloat(order.available_community_hubs.filter((s) => (s.id === hub))[0].price);
  }
  if (deliveryMode && (deliveryMode === 'market')) {
    return 0.0;
  }
  if (hub) {
    return parseFloat(order.available_community_hubs.filter((s) => (s.id === hub))[0].price);
  }
  if (service) {
    return parseFloat(order.available_delivery_services.filter((s) => (s.id === service))[0].price);
  }
  if (order.delivery_service) {
    return parseFloat(order.delivery_service.price);
  }
  if (order.market_community_hub) {
    return parseFloat(order.market_community_hub.price);
  }
  if (order.hub) {
    return parseFloat(order.hub.price);
  }
  if (order.available_delivery_services) {
    return parseFloat(order.available_delivery_services[0].price);
  }
  return 0.0;
};

const calculateDiscount = (order) => {
  if (!order.coupon) {
    return 0.0;
  }
  if (order.coupon.dollar_discount) {
    return parseFloat(order.coupon.dollar_discount);
  }
  if (order.coupon.percent_discount) {
    return calculateTotal(order) * parseFloat(order.coupon.percent_discount);
  }
  return 0.0;
};

const calculateBalanceToApply = (order, basedOnTotal) => {
  if (!order.apply_balance) {
    return 0.0;
  }
  if (order.apply_balance < basedOnTotal) {
    return order.apply_balance;
  }
  return basedOnTotal;
};

const calculateFees = (order, totals) => {
  let fees = 0;
  if (order.market_event.market?.id) {
    console.log("Calculating virtual market fees");
    const fee_formula = order.market_event.market.fee_formula;
    if (fee_formula) {
      console.log('using formula', fee_formula);
      try {
        const a = fee_formula.split('*');
        fees = totals[a[0]] * parseFloat(a[1]);
      } catch (err) {
        fees = totals.subtotal * 0.1;
      }
    } else {
      console.log('with default fee');
      fees = totals.subtotal * 0.1;
    }
    console.log('plus base fee');
    fees += totals.base * 0.01;
  } else if (order.market_event.direct_location?.id) {
    console.log("Calculating vendor direct fees");
    const fee_formula = order.market_event.direct_location.fee_formula;
    if (fee_formula) {
      console.log('using formula', fee_formula);
      try {
        const a = fee_formula.split('*');
        fees = totals[a[0]] * parseFloat(a[1]);
      } catch (err) {
        fees = totals.subtotal * 0.1;
      }
    } else {
      console.log('no applicable fee formula found');
    }
  } else {
    console.warn("Unknown fees, order is for netiher a vendor direct nor virtual market");
  }
  return fees;
};

const calculate = (order, service, hub) => {
  const useHub = hub || order.market_community_hub?.id;
  const useService = service || order.delivery_service?.id;
  const totals = {};
  totals.subtotal = calculateTotal(order);
  totals.delivery = calculateDelivery(order, useService, useHub, totals.subtotal, order.delivery_mode);
  totals.discount = calculateDiscount(order);
  totals.base = totals.subtotal + totals.delivery - totals.discount;
  totals.fees = order.snap ? 0 : calculateFees(order, totals);
  totals.total = totals.base + totals.fees;
  totals.byWeight = calculateTotalByWeight(order);
  if (order.order_state === 'Started') {
    totals.flex = totals.byWeight * 0.15;
  } else {
    totals.flex = 0;
  }
  totals.balanceApplied = calculateBalanceToApply(order, totals.total + totals.flex);
  if (order.snap) {
    totals.auth = 0;
  } else if (order.order_state === 'Started') {
    totals.auth = totals.total + totals.flex - totals.balanceApplied;
  } else {
    totals.auth = parseFloat(order.total);
  }
  return totals;
};

const Order = ({
  order,
  onChange,
  placeOrder,
  chargeAmount,
  setChargeAmount,
}) => {
  const totals = calculate(order);
  const workingAuth = Math.round((parseFloat(order.total) + parseFloat(order.applied_balance || 0)) * 100) / 100;
  return (
    <div>
      { order.order_products.filter((op) => (op.product)).length > 0 && (
      <div css={css` margin-left: 1rem; padding-top: 2rem; display: flex; flex-direction: column; align-items: stretch; width: calc(100% - 2rem); `}>
        <div css={{ textAlign: 'center' }}>
          <div>
            Order #{order.id}
          </div>
          <div css={{ color: '#666666', fontSize: '1rem' }}>
            {order.market_event.market.name}{order.market_event.direct_location.name}

          </div>
          <div css={{ color: '#666666', fontSize: '1rem' }}>
            {moment(order.market_event.start).format('ddd, MMM D')},
            &nbsp;
            {moment(order.market_event.start).format('h a')}
            &nbsp;-&nbsp;
            {moment(order.market_event.end).format('h a')}
          </div>
          <div css={{ color: '#666666', fontSize: '1rem', marginBottom: '1rem' }}> Ordering open through&nbsp;
            { moment(order.market_event.order_window_close).format('ddd, MMM D') }&nbsp;
            @&nbsp;{ moment(order.market_event.order_window_close).format('h a') }
          </div>
        </div>
        <div>
          { order.order_products.map((orderProduct) => (
            <OrderProduct
              key={orderProduct.id}
              orderProduct={orderProduct}
              productCategory={orderProduct.product_category}
              editable={order.order_state === 'Started'}
              adjustable={order.order_state === 'Submitted'}
              onChange={onChange}
            />
          ))}
        </div>
        <div>
          <div css={{
            display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
          }}
          >
            <div css={{ flex: 2 }} />
            <div css={{ flex: 1, textAlign: 'right', fontWeight: 'bold' }}>
              Subtotal:
            </div>
            <div css={{ flex: 1, textAlign: 'right' }}>
              ${totals.subtotal.toFixed(2)}
            </div>
          </div>
        </div>
        { (order.order_state === 'Started') && placeOrder
        && (
        <div>
          <div css={css` margin-bottom: 1rem; display: flex; flex-direction: row; align-items: center; justify-content: center; @media print { display: none; } `}>
            <Button
              variant="primary"
              onClick={() => placeOrder(order)}
            >
              Checkout
            </Button>
          </div>
        </div>
        )}
        { order.order_state !== 'Started'
        && (
        <div>
          <div css={css` display: flex; flex-direction: row; align-items: center; justify-content: center; @media print { display: none; } `}>
            <Button
              variant="primary"
              style={{ marginTop: '20px' }}
              onClick={() => {
                placeOrder(order, chargeAmount || order.total, () => {
                  setChargeAmount(undefined);
                });
              }}
            >
              Complete and Charge Order
            </Button>
            <TextField
              id="email"
              value={chargeAmount}
              css={{ width: '6rem', marginLeft: '2rem' }}
              onChange={(e) => { setChargeAmount(e.target.value); }}
            />
            { parseFloat(chargeAmount) > workingAuth
              && (
                <div css={{ color: '#a00' }}>
                  <span role="img" aria-label="warning">⚠️</span>over: ${ Math.round((parseFloat(chargeAmount) - workingAuth) * 100) / 100}
                </div>
              )}
          </div>
        </div>
        )}
      </div>
      )}
    </div>
  );
};

const productCount = (order) => order.order_products.reduce(
  ((count, { requested_quantity: rq }) => count + rq),
  0,
);

export {
  Order as default,
  calculate,
  calculateTotal,
  calculateTotalByWeight,
  calculateDiscount,
  calculateFees,
  calculateDelivery,
  productCount,
};
